import { render, staticRenderFns } from "./EmailMarketingMessageTemplate.vue?vue&type=template&id=4aa21cd1&scoped=true"
import script from "./EmailMarketingMessageTemplate.vue?vue&type=script&lang=js"
export * from "./EmailMarketingMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./EmailMarketingMessageTemplate.vue?vue&type=style&index=0&id=4aa21cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa21cd1",
  null
  
)

export default component.exports